import { useQuery } from "@tanstack/react-query";
import { callApi, HttpMethod } from "src/services/apiService";
import type { ProductKey } from "src/constants/productKeys";

export interface SignupAccess {
  productKey: ProductKey;
  hasAccess: boolean;
  canPurchase: boolean;
}

export function useSignupAccess(productKey: ProductKey, enabled = true) {
  return useQuery<SignupAccess>({
    queryKey: ["signup", productKey],
    queryFn: () => callApi(`api/signup/access/${productKey}`, HttpMethod.GET),
    staleTime: 5 * 60 * 1000,
    enabled,
  });
}
